import { render } from "./SessionHeader.vue?vue&type=template&id=d31c7e0e&scoped=true"
import script from "./SessionHeader.vue?vue&type=script&lang=js"
export * from "./SessionHeader.vue?vue&type=script&lang=js"

import "./SessionHeader.vue?vue&type=style&index=0&id=d31c7e0e&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d31c7e0e"]])

export default __exports__